import redirectInterceptor from "@/interceptors/redirect_interceptor";

const getDefaultState = () => {
  return {
    foulingData: null,
    foulingDataLoading: true,
    foulingDataError: null,
  };
};

const state = getDefaultState();

const getters = {
  displayFouling(state) {
    try {
      return state.foulingData.trends.preds_linear.toFixed(3);
    } catch (error) {
      return "-";
    }
  }
};

const actions = {
  async fetchFoulingData({ commit }, payload) {
    const basicUrl = localStorage.getItem("basicUrl");
    const vesselName = payload.name;
    const date = payload.date;
    commit("SET_FETCH_FOULING_DATA_LOADING_STATE");

    const response = await redirectInterceptor.get(`${basicUrl}/vesselInformation/${vesselName}/latestFoulingData`, {
      params: {
        date: date
      },
      headers: {
        Authorization: localStorage.getItem("quad_token")
      }
    });
    if (response.status === 200) {
      commit("SET_FETCH_FOULING_DATA_SUCCESS_STATE", response.data);
    }
    else {
      commit("SET_FETCH_FOULING_DATA_ERROR_STATE");
    }
  }
};

const mutations = {
  SET_FETCH_FOULING_DATA_LOADING_STATE(state) {
    state.foulingDataLoading = true;
    state.foulingDataError = null;
  },
  SET_FETCH_FOULING_DATA_ERROR_STATE(state) {
    state.foulingDataLoading = false;
    state.foulingDataError = "Could not fetch fouling data";
  },
  SET_FETCH_FOULING_DATA_SUCCESS_STATE(state, data) {
    state.foulingDataLoading = false;
    state.foulingDataError = null;
    state.foulingData = data;
  },
};

export const foulingModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
